var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"button whatsapp"},[_c('ShareNetwork',{attrs:{"network":"whatsapp","url":_vm.link,"title":_vm.fixedTitle}},[_c('img',{attrs:{"src":require("@/assets/socialicons/whatsapp.png")}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }